import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { createTheme, ThemeProvider } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    neutral: Palette["primary"];
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#FF8400",
    },
  },
});

export default function BackdropLoadingScreenHM({
  openState,
}: {
  openState: boolean;
}) {
  return (
    <ThemeProvider theme={theme}>
      <div>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            display: "flex",
            flexDirection: "column", // Stack items vertically
            alignItems: "center", // Center items horizontally
            justifyContent: "center", // Center items vertically
          }}
          open={openState}
        >
          <CircularProgress color="primary" />
          <div style={{ textAlign: "center", marginTop: "16px" }}>
            <div className="text-white text-[18px]">
              Loading Health Monitoring Data.
            </div>
            <div className="text-white text-[18px]">
              Larger date ranges may take longer to load.
            </div>
          </div>
        </Backdrop>
      </div>
    </ThemeProvider>
  );
}
